import { makeCall, Methods } from "../../utils/makeCall";
import { GetAdPriceErrors } from "./adPrice.error";

export type GetAdPriceRequest = {
  ad_id: string
};
export type GetAdPriceResponse = {
  total_price: number;
  discounted_amount: number;
  final_price: number;
};

export const getAdPrice = makeCall<
  GetAdPriceRequest,
  GetAdPriceResponse,
  GetAdPriceErrors
>(Methods.GetAdPrice);
